import React from 'react';
import DatePicker from './DatePicker';
import Field from './../field/Field';
import Grid from '@material-ui/core/Grid';

// clientId:              string  - mandatory
//     affiliateId:           string  - mandatory
//     appId:                 string  - mandatory
//     dateStart:             numeric - optional
//     dateEnd:               numeric - optional
//     quantity:              numeric - optional
//     topic:                 string  - optional


export const filteringOptions = ['dateStart', 'dateEnd', 'quantity', 'topic'];

export const generateFilterOption = (option, callback, removeCallback) => {
    switch (option) {
        case filteringOptions[0]:
            return (
                <Grid item xs={3}>
                    <DatePicker
                        title="Start Date"
                        name="dateStart"
                        start="true"
                        callback={callback}
                        removeCallback={removeCallback} />
                </Grid>);
        case filteringOptions[1]:
            return (
                <Grid item xs={3}>
                    <DatePicker
                        title="End Date"
                        name="dateEnd"
                        callback={callback}
                        removeCallback={removeCallback} />
                </Grid>
            );
        case filteringOptions[2]:
            return (
                <Grid item xs={4}>
                    <Field
                        title="Quantity"
                        id="quantity"
                        name="quantity"
                        placeholder="default is 10, max is 100"
                        error_msg="Should not be empty"
                        listener={callback}
                        removeCallback={removeCallback}
                    />
                </Grid>
            );
        case filteringOptions[3]:
            return (
                <Grid item xs={4}>
                    <Field
                        title="Topic"
                        id="topic"
                        name="topic"
                        placeholder="notification topic: either airfind or airfind-test"
                        error_msg="Should not be empty"
                        listener={callback}
                        removeCallback={removeCallback}
                    />
                </Grid>
            );
        default:
            return (<div></div>);
    }
}